// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"19741ac6","764":"55818f42","787":"a0be78c4","797":"0650e92b","821":"bdf0c68c","979":"f20c3f58"}[chunkId] + ".chunk.js";
};